export function getStrongDiv(
  text: string,
  divClasses: string[] = [],
  strongClasses: string[] = [],
  divId: string | null = null,
  strongId: string | null = null
): HTMLDivElement {
  const keyDiv = document.createElement("div");
  keyDiv.classList.add(...divClasses);
  if (divId) keyDiv.id = divId;

  const keyStrong = document.createElement("strong");
  keyStrong.textContent = text;
  keyStrong.classList.add(...strongClasses);
  if (strongId) keyStrong.id = strongId;

  keyDiv.appendChild(keyStrong);
  return keyDiv;
}

export function isElementVisibleInContainer(element: HTMLElement, container: HTMLElement): boolean {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  const elementMiddle = elementRect.top + elementRect.height / 2;

  return elementMiddle >= containerRect.top && elementMiddle <= containerRect.bottom;
  // return elementRect.top >= containerRect.top && elementRect.bottom <= containerRect.bottom;
}
